module.exports = __webpack_public_path__ + "static/media/default.82ddf62b.svg";